import { isNumber } from '../common';

export default function firstDay(options, intlService) {
    if (isNumber(options.weekStartDay)) {
        return options.weekStartDay;
    }

    if (intlService && intlService.firstDay) {
        return intlService.firstDay();
    }

    return 0;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/date-utils/first-day.js
// module id = 2383
// module chunks = 29